import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ForwardingApi} from '../../api/forwarding/forwarding.api.class';
import {TransactionRef} from '../../components/error-handling/error-handling.component';

@Injectable({
  providedIn: 'root'
})
export class ForwardingService {

  constructor(private forwardingApi: ForwardingApi) { }

  public forwardError(sessionToken: string): Observable<TransactionRef> {
    return this.forwardingApi.forwardError(sessionToken);
  }

}
